import { api } from "./api";
import { ListRequest } from "../types/common/commonTypes";
import {
  UOMTypeFull,
  UOMTypeCreate,
  UOMTypeUpdate,
  PaginatedUOMTypeResponse,
} from "../types/uomTypes";
/**
 * UOM Types Service
 *
 * Handles all API operations for Unit of Measure Types.
 * UOM Types define categories of measurements (e.g., Weight, Volume, Length)
 * with precision settings and base units.
 */
const type_base = "/inventory/uom/types";
export const uomTypesService = {
  list: async (params: ListRequest): Promise<PaginatedUOMTypeResponse> => {
    const response = await api.post(`${type_base}/search`, params);
    return response.data;
  },

  /**
   * Get UOM type by ID
   * GET /api/v1/uom/types/{uom_type_id}
   * Returns UOM type with base unit and all associated units
   */
  getById: async (id: string): Promise<UOMTypeFull> => {
    const response = await api.get(`${type_base}/${id}`);
    return response.data;
  },

  /**
   * Create a new UOM type
   * POST /api/v1/uom/types
   * Note: Base unit is automatically created when UOM type is created
   */
  create: async (data: UOMTypeCreate): Promise<UOMTypeFull> => {
    const response = await api.post(`${type_base}/`, data);
    return response.data;
  },

  /**
   * Update UOM type
   * PUT /api/v1/uom/types/{uom_type_id}
   */
  update: async (id: string, data: UOMTypeUpdate): Promise<UOMTypeFull> => {
    const response = await api.put(`${type_base}/${id}`, data);
    return response.data;
  },

  /**
   * Delete UOM type (cascades to all units and item units)
   * DELETE /api/v1/uom/types/{uom_type_id}
   * WARNING: This will delete all associated UOM units and Item UOM units
   */
  deactivate: async (id: string): Promise<UOMTypeFull> => {
    const response = await api.delete(`${type_base}/${id}`);
    return response.data;
  },

  reactivate: async (id: string): Promise<UOMTypeFull> => {
    const response = await api.put(`${type_base}/${id}/restore`);
    return response.data;
  },
};
